import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectsDirectoryRedirectRoute: InvariantJiraRoute = {
	name: 'projects-directory-redirect',
	path: '/projects',
	exact: true,
};
